import { render, staticRenderFns } from "./ChoseStaff.vue?vue&type=template&id=05d62146&"
import script from "./ChoseStaff.vue?vue&type=script&lang=js&"
export * from "./ChoseStaff.vue?vue&type=script&lang=js&"
import style0 from "./ChoseStaff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports